import { putAfericaoBico } from '../offline/api';

export async function registrarBico(afericaoId, numeroBico, valor, imagemBlob) {
  // Obter localização atual
  const position = await new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject, {
      enableHighAccuracy: true,
      timeout: 10000
    });
  });

  const localizacaoLat = position.coords.latitude;
  const localizacaoLng = position.coords.longitude;

  // Criar FormData para envio
  const formData = new FormData();
  formData.append('valor', valor.toString());
  formData.append('localizacaoLat', localizacaoLat.toString());
  formData.append('localizacaoLng', localizacaoLng.toString());

  // Adicionar imagem como blob (bytes)
  if (imagemBlob) {
    formData.append('imagem', imagemBlob, 'afericao.jpg');
  }

  try {
    await putAfericaoBico(afericaoId, numeroBico, formData);
  } catch (error) {
    console.error('Erro ao registrar bico:', error);
    throw new Error('Erro ao registrar bico. Tente novamente.');
  }
}

